import "./Arrow.css";
const Arrow = ({ direction = "down", className = "", size = "1rem", width = "5px" }) => {
    className += ` arrow--${direction}`;
    return (
        <i className={`arrow ${className}`} style={{ "--size": size, "--width": width }}></i>
    );
};

export default Arrow;